import { render, staticRenderFns } from "./DeviceColorStatus.vue?vue&type=template&id=34dda03c&"
import script from "./DeviceColorStatus.vue?vue&type=script&lang=js&"
export * from "./DeviceColorStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports